module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE0IDE4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgPHBhdGggZD0iTS01LTNoMjR2MjRILTV6Ii8+CiAgICAgICAgPHBhdGggY2xhc3M9InRyYXNoLWljb25fX3BhdGgiIGQ9Ik0xIDE2YzAgMS4xLjkgMiAyIDJoOGMxLjEgMCAyLS45IDItMlY0SDF2MTJ6TTE0IDFoLTMuNWwtMS0xaC01bC0xIDFIMHYyaDE0VjF6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/trash.svg
// module id = FapF
// module chunks = 1